export const DEFAULT_LOGO_URL = '/images/account-default-image.svg';
export const DEFAULT_NAME = 'Personal Account';

export const memberActions = {
  approveRequest: 'approveRequest',
  cancelInvite: 'cancelInvite',
  denyRequest: 'denyRequest',
  removeMember: 'removeMember',
  resendInvite: 'resendInvite',
};
